export const CONFIG = {
  infiniteLimit: 2000,
};

export default CONFIG;
